'use strict'
import { request } from '../../plugins/http'

export default async (path) => {
    return await request.get(path,{responseType:'blob'})
}